import { Center, VStack, Icon, Heading } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import EmptyFolderGraphic from '../../../../graphics/media-library/EmptyFolderGraphic'
import { useTranslation } from 'react-i18next'

const EmptyFolderView = (): ReactElement => {
  const { t } = useTranslation()
  return (
    <Center height="100%" width="100%">
      <VStack spacing={6}>
        <Icon
          as={EmptyFolderGraphic}
          width="260px"
          height="200px"
          color="appClearBlue"
        />

        <Heading as="h4" fontSize="lg" color="appBattleshipGrey">
          {t('empty_folder', 'Empty folder')}
        </Heading>
      </VStack>
    </Center>
  )
}

export default EmptyFolderView
